import type { AccountInfo } from "@azure/msal-browser"
import { useMsal } from "@azure/msal-react"
import config from "@/v2-backoffice-client/config"

/**
 * Extracts the `groups` optional claim from an MSAL account's ID token claims.
 * Requires the "groups" optional claim to be configured in the Azure AD app
 * registration under Token Configuration.
 */
function getGroupsFromAccount(account: AccountInfo | null): string[] {
  if (!account?.idTokenClaims) return []

  const groups = account.idTokenClaims["groups"]
  if (!Array.isArray(groups)) return []

  return groups as string[]
}

export function useAccountGroups(): string[] {
  const { accounts } = useMsal()
  return getGroupsFromAccount(accounts[0] ?? null)
}

export function useIsAdvancedUser(): boolean {
  const groups = useAccountGroups()
  const { azAuthAdvancedGroupId } = config
  if (!azAuthAdvancedGroupId) return false
  return groups.includes(azAuthAdvancedGroupId)
}
